/**
 * About Us — from the client's finalized copy (updated 7/12/26).
 */
import founder1 from './founder-1.jpg';
import founder2 from './founder-2.jpg';

const content = [
  { type: 'h2', text: 'Who are we?' },
  {
    type: 'p',
    text:
      "We're Saam and Amy — a married couple, parents of a 20-month-old and a five-year-old, and the two people behind KidHive. Saam is an engineer with a career in aerospace and defense; Amy is an oncology pharmacist who has cared for both kids and adults. An engineer's rigor and a clinician's care go into everything we build.",
  },

  { type: 'h2', text: 'What were we struggling with?' },
  {
    type: 'p',
    text:
      "Between two little ones and two full-time jobs, our weeks are a constant juggle — and finding fun, safe activities for our kids used to make it harder, not easier. The good options were scattered across Facebook groups, flyers, and outdated websites. Signing up meant phone calls and paper forms, refunds were a mystery, and more than once we paid before we even knew if a program was any good or right for our kids' ages.",
  },

  { type: 'h2', text: 'Why did we build KidHive?' },
  {
    type: 'p',
    text:
      "After one too many nights lost to open browser tabs, we realized the activities weren't the problem — finding and trusting them was. So we built the tool we wished we'd had.",
  },

  { type: 'h2', text: 'What is KidHive?' },
  {
    type: 'p',
    text:
      'KidHive is one trustworthy place to discover local camps, classes, and sports, with clear details and easy booking and payment — so the right fit for your child takes minutes instead of evenings.',
  },
  {
    type: 'p',
    text:
      "KidHive is built for two people: the parent trying to find the right class, camp, or program for their kid without losing an evening to it — and the local provider who's great at what they do but shouldn't have to be a marketer too. Parents get everything in one searchable place. Providers get listed, get found, and get booked.",
  },

  { type: 'h2', text: "What's next?" },
  {
    type: 'p',
    text:
      "KidHive today is just the beginning. We're fully dedicated to making it succeed — for our family and for every parent who shares the juggle — and we'll keep improving it with feedback from the parents and businesses who use it.",
  },
  {
    type: 'p',
    text: "Thanks for being here. We can't wait to help you find your kids' next favorite thing.",
  },

  {
    type: 'founders',
    images: [
      { src: founder1, alt: 'KidHive co-founder' },
      { src: founder2, alt: 'KidHive co-founder' },
    ],
    name: '— Saam & Amy',
    role: 'Co-founders, KidHive',
  },
];

export default content;
